import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import { API_BASE_URL, Assets_URL } from "../../../Apicongfig";
import axios from "axios";
import { FaArrowRight, FaCheckCircle, FaQuestionCircle, FaTimesCircle } from "react-icons/fa";
import ParticipantCardProfile from "../../Profile/ParticipantCardProfile";
import { useTranslation } from "react-i18next";
const Participant = ({
  data,
  disabled,
  guides,
  handleShow,
  handleHide,
  showProfile,
  refreshedData,
  meeting
}) => {
  const [participants, setParticipants] = useState([]); // participants.
  const [t] = useTranslation("global");

  useEffect(() => {
    setParticipants(data);
  }, [data]);

  const guideEmails = new Set(guides?.map((guide) => guide.email));

  const [selectedIndex, setSelectedIndex] = useState(null);
  const handleItemClick = async (index, item) => {
    setSelectedIndex(index === selectedIndex ? null : index);

    const newAttendanceStatus = item?.attandance ? 0 : 1;
    const reuestBODY = {
      first_name: item.first_name,
      last_name: item.last_name,
      email: item.email,
      post: item.post,
      attandance: newAttendanceStatus,
      isCreator: item.isCreator,
      _method: "put",
    };
    const requestURL = `${API_BASE_URL}/participants/${item.id}`;

    try {
      const response = await axios.post(requestURL, reuestBODY, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      });
      // Update the state with the updated participant data
      const updatedParticipant = response?.data?.data;

      setParticipants((prevParticipants) =>
        prevParticipants.map((participant) =>
          participant.id === updatedParticipant.id
            ? updatedParticipant
            : participant
        )
      );
      await refreshedData();
    } catch (error) {
      console.log("FAILED TO UPDATE THE ATTENDANCE", error);
    }
  };

  const [id, setId] = useState(null);
  const handleShowProfile = (userId) => {
    handleShow();
    setId(userId);
  };
  return (
    <>
      {showProfile ? (
        <div>
          <ParticipantCardProfile userId={id} handleHide={handleHide} />
        </div>
      ) : (
        <div className="row">
          {participants.map((item, index) => {
            return (
              <div className="col-md-3" key={index}>
                <Card
                  className="participant-card position-relative"
                  style={{
                    border: meeting?.type === "Google Agenda Event" ?  item?.attendee_response_status === "accepted"
                    ? "1px solid green"
                    : item?.attendee_response_status === "declined"
                    ? "1px solid red"
                    : "1px solid grey" :
                      item?.attandance === 1
                        ? "1px solid green"
                        : "1px solid red",
                    cursor: "pointer",
                    marginTop: "4rem",
                    borderRadius: "26px",
                    position: "relative",

                  }}
                  onClick={() => {
                    if (disabled) {
                      return;
                    }
                    handleItemClick(index, item);
                  }}
                >
                   {/* Tick or Cross Icon at Bottom Center */}
                                    {meeting?.type === "Google Agenda Event" && (
                                      <>
                                        {item?.attendee_response_status === "accepted" && (
                                          <FaCheckCircle
                                            style={{
                                              position: "absolute",
                                              bottom: "-10px",
                                              left: "50%",
                                              transform: "translateX(-50%)",
                                              background: "white",
                                              borderRadius: "50%",
                                              padding: "2px",
                                              color: "green",
                                              fontSize: "1.5rem",
                                            }}
                                          />
                                        )}
                  
                                        {item?.attendee_response_status === "declined" && (
                                          <FaTimesCircle
                                            style={{
                                              position: "absolute",
                                              bottom: "-10px",
                                              left: "50%",
                                              transform: "translateX(-50%)",
                                              background: "white",
                                              borderRadius: "50%",
                                              padding: "2px",
                                              color: "red",
                                              fontSize: "1.5rem",
                                            }}
                                          />
                                        )}
                                        {item?.attendee_response_status === "needsAction" && (
                                          <FaQuestionCircle
                                            style={{
                                              position: "absolute",
                                              bottom: "-10px",
                                              left: "50%",
                                              transform: "translateX(-50%)",
                                              background: "white",
                                              borderRadius: "50%",
                                              padding: "2px",
                                              color: "grey",
                                              fontSize: "1.5rem",
                                            }}
                                          />
                                        )}
                                      </>
                                    )}
                  <Card.Body
                    style={{
                      padding: "20px 0px 20px 0",
                    }}
                  >
                    <div className="d-flex justify-content-center">
                      <div className="participant-card-position">
                        <div className="profile-logo">
                          {item?.participant_image?.startsWith("users/") ? (
                            <Card.Img
                              className="user-img"
                              src={`${Assets_URL}/${item?.participant_image}`}
                            />
                          ) : item?.participant_image ? (
                            <Card.Img
                              className="user-img"
                              src={item?.participant_image}
                            />
                          ) : (
                            <Card.Img
                              className="user-img"
                              src="/Assets/avatar.jpeg"
                            />
                          )}
                          <Card.Img
                            className="logout-icon"
                            src="/Assets/Avatar_company.svg"
                            height="20px"
                            width="20px"
                            alt="tektime"
                          />
                        </div>
                      </div>
                    </div>

                    <Card.Title className="text-center mt-4 card-heading">
                      {item.first_name} {item.last_name}
                    </Card.Title>
                    {meeting?.type === "Google Agenda Event" &&  item?.full_name === " " &&                  
                    <Card.Title className="text-center mt-4 card-heading">
                                          {item.email}
                                        </Card.Title>}
                    <Card.Subtitle className="mb-2 card-subtext">
                      {item.post} {item?.team_names?.length > 0 && "-"} &nbsp;
                      {item?.team_names?.map((item) => item).join(", ")}
                    </Card.Subtitle>
                    {item?.contribution && (
                      <>
                        <Card.Subtitle className="mb-3 mt-3 card-subtext">
                          {item?.contribution}
                        </Card.Subtitle>
                      </>
                    )}
                    {item?.user_id && (
                      <div
                        className="visiting-card-link"
                        onClick={(e) => {
                          e.stopPropagation(); // Prevents click from bubbling up to Card
                          handleShowProfile(item?.id);
                        }}
                      >
                        {t("viewVisitingCard")} &nbsp; <FaArrowRight />
                      </div>
                    )}
                  </Card.Body>
                </Card>
              </div>
            );
          })}
        </div>
      )}
    </>
  );
};

export default Participant;
